import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Settings, AppSettings } from './app.settings';
import { AppService } from './app.service';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { MessagingService } from './service/messaging.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  loading: boolean = false;
  user_id: any;
  message: any;
  public settings: Settings;
  constructor(public appSettings: AppSettings, public appService: AppService, public router: Router,
    protected localStorage: LocalStorage,
    private messagingService: MessagingService,
    @Inject(PLATFORM_ID) private platformId: Object,) {
    this.settings = this.appSettings.settings;

  }
  ngOnInit() {
    this.messagingService.requestPermission() // firebase pushnotification disabled
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage
    // this.router.navigate(['']);  //redirect other pages to homepage on browser refresh    
  }



  ngAfterViewInit(){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo(0,0);
        } 
      }
    })  
  }


}
